const STORAGE_PREFIX = 'tasks-rewarded-';

const getLocalDateKey = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const getStorageKeyForToday = (): string => {
  return STORAGE_PREFIX + getLocalDateKey();
};

const getRewardedToday = (): Set<number> => {
  try {
    const key = getStorageKeyForToday();
    const raw = localStorage.getItem(key);
    if (!raw) {
      return new Set<number>();
    }

    const parsed: number[] | null = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return new Set<number>();
    }

    return new Set<number>(parsed);
  } catch {
    return new Set<number>();
  }
};

export const markRewarded = (taskId: number): void => {
  try {
    const key = getStorageKeyForToday();
    const current = getRewardedToday();

    if (!current.has(taskId)) {
      current.add(taskId);
      localStorage.setItem(key, JSON.stringify(Array.from(current)));
    }
  } catch {
    return;
  }
};

export const getRemaining = (maxPerDay: number): number => {
  const used = getRewardedToday().size;

  return Math.max(0, maxPerDay - used);
};

export const isLimitReached = (maxPerDay: number): boolean => {
  return getRewardedToday().size >= maxPerDay;
};
